import UserContainer from 'documents-ui/lib/containers/UserContainer';
import UserViewRecord from 'SalesContentIndexUI/data/records/UserViewRecord';
export default (userId => {
  const user = UserContainer.get();
  if (userId && userId !== user.user_id) {
    return UserViewRecord();
  }
  return UserViewRecord({
    firstName: user.first_name,
    lastName: user.last_name,
    email: user.email
  });
});